module.exports = __webpack_public_path__ + "3f4cb6e0aa181defc0e01b70655fe18d.jpg";